export const NO_SEARCH_RESULTS = 'No search results'
